<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-bootbutton
            title="افزودن منو"
            type="primary"
            icon="fas fa-plus-square"
            btn-width="200px"
            @click.native="openModal"
            v-if="$acl.can('create', 'menus')"
          />
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
    <menu-form
      ref="menuform"
      id="menu-form"
      title="افزودن منو"
      :is-loading="isLoadingModal"
      :props-data="updateForm"
      @on-create="create"
      @on-update="update"
    />
  </div>
</template>
<script>
import { menuApi } from "@/api/apiManagement";
import MenuForm from "./components/MenuForm";
export default {
  components: { MenuForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "منوها", link: "/shop/menus" },
      ],
      isLoadingGrid: false,
      isLoadingModal: false,
      updateForm: {},
    };
  },
  computed: {
    gridColumns() {
      return [
        // {
        //   field: "icon_url",
        //   title: "تصویر",
        //   template: (e) => (e.icon_url ? this.getPicture(e.icon_url) : ""),
        // },
        {
          field: "type",
          title: "نوع",
          template: (e) => (e.type ? this.getMenuType(e.type) : ""),
        },
        { field: "title", title: "عنوان" },
        { field: "status", title: "وضعیت", template: this.statusIcon },
        { field: "order", title: "اولویت" },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
        },
      ];
    },
  },
  methods: {
    statusIcon(e) {
      let view = e.status == 1 ? "fas fa-lock-open" : "fas fa-lock";
      let color = e.status == 1 ? "green" : "red";
      return `<span class="${view}" style="color:${color}"></span>`;
    },
    getPicture: function (icon) {
      return (
        '<div class="rounded-circle rounded-image-grid" ' +
        (icon ? "" : "no-pic") +
        'style="background-image:url(' +
        (icon ? icon : "") +
        ')">' +
        (icon ? "" : '<i class="fa fa-file-image-o" aria-hidden="true"></i>') +
        "</div>"
      );
    },
    getMenuType(type) {
      switch (type) {
        case 1:
          return "فوتر";

        default:
          return "";
      }
    },
    readData(e) {
      this.isLoadingGrid = true;
      menuApi
        .getMenus()
        .then((res) => {
          e.success(res.data.entity);
        })
        .catch((res) => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    gridCommands() {
      let commands = [];
      if (this.$acl.can("edit", "menus")) {
        commands.push({
          text: "edit",
          click: this.edit,
          template: this.gridButtons.edit,
        });
      }
      if (this.$acl.can("edit", "menu-items")) {
        commands.push({
          text: "items",
          click: this.editItems,
          template: this.gridButtons.items,
        });
      }

      if (this.$acl.can("delete", "menus"))
        commands.push({
          text: "delete",
          click: this.delete,
          template: this.gridButtons.delete,
        });
      return commands;
    },
    editItems(e) {
      let dataItem = this.$refs.grid.getSelectedGridRow(e);
      this.$router.push(`menus/${dataItem.id}/items`);
    },
    edit(e) {
      let dataItem = this.$refs.grid.getSelectedGridRow(e);
      this.updateForm = {
        id: dataItem.id,
        title: dataItem.title,
        type: dataItem.type,
        icon_url: dataItem.icon_url,
        order: dataItem.order,
        status: dataItem.status,
      };
      this.toggleForm();
    },
    delete(e) {
      let page = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف صفحه ${page.title} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          menuApi
            .deleteMenu(page.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    create(e) {
      this.isLoadingModal = true;
      menuApi
        .createMenu(this.$getFormData(e))
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.loadData();
          this.toggleForm();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    update(e) {
      this.isLoadingModal = true;
      menuApi
        .updateMenu(e.id, this.$getFormData(e))
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.loadData();
          this.toggleForm();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    openModal() {
      this.updateForm = {};
      this.toggleForm();
    },
    toggleForm() {
      this.$toggleModal("#menu-form");
    },
  },
};
</script>